import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Rx";
import {Http, ConnectionBackend, Request, RequestOptionsArgs, Response, RequestOptions} from "@angular/http";
import {AuthentService} from "./authent.service";

@Injectable()
export class RequestService extends Http {

    constructor(_backend:ConnectionBackend, _defaultOptions:RequestOptions, private authent:AuthentService) {
        super(_backend, _defaultOptions);
    }

    request(url:string|Request, options?:RequestOptionsArgs):Observable<Response> {
        return undefined;
    }

    get(url:string, options?:RequestOptionsArgs):Observable<Response> {
        return super.get(url, this.authent.getAuthentHeaders());
    }

    post(url:string, body:any, options?:RequestOptionsArgs):Observable<Response> {
        return undefined;
    }

    put(url:string, body:any, options?:RequestOptionsArgs):Observable<Response> {
        return undefined;
    }

    delete(url:string, options?:RequestOptionsArgs):Observable<Response> {
        return undefined;
    }

    patch(url:string, body:any, options?:RequestOptionsArgs):Observable<Response> {
        return undefined;
    }

    head(url:string, options?:RequestOptionsArgs):Observable<Response> {
        return undefined;
    }

    options(url:string, options?:RequestOptionsArgs):Observable<Response> {
        return undefined;
    }


}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/request.service.ts